<template>
    <div id="app">
      <yetkidialog ref="yetkidialog"></yetkidialog>
      <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
      <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
      <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="510px">

<v-card>
  <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
  <v-divider></v-divider>
  <v-card-text>

    <v-card flat="" class="white--text">
      <v-card flat="">
        <v-card-actions>
          <v-layout row="" wrap="">
            <v-flex xs12 sm12 md12>
            <v-select hide-details="" :items="dovizTipleri" label="Ekstre Tipi" item-text="text" v-model="searchParams.ExtractType" item-value="value">
                                    </v-select>
          </v-flex>
            <v-flex xs12 sm12 md12>
                  <catimuhasebekodu
                    v-model="accoutingCode"
                    :controlValue="accoutingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    :text="$t('Start-Accounting-Code')"
                    @validateCheck="checkAccoutingValidate()"
                    :Coper="false"
                  >
                  </catimuhasebekodu>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <catimuhasebekodu
                    v-model="endAccoutingCode"
                    :controlValue="endAccoutingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    :text="$t('End-Accounting-Code')"
                    @validateCheck="checkAccoutingValidate()"
                    :Coper="false"
                  >
                  </catimuhasebekodu>
                </v-flex>
                <v-flex xs12 sm12 md12>
              <v-checkbox v-model=searchParams.ExcludeClosingFiche
      label="Kapanış Fişini Dahil Etme" false-value="0"
    true-value="1"
    ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-card-text>
  <v-divider></v-divider>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{ $t('cancel_button') }} </v-btn>
    <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
  </v-card-actions>
</v-card>


</v-dialog>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Referansa Göre</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                flat=""
                solo-inverted=""
                hide-details
                v-model="search"
                :label="$t('Search')"
                append-icon="search"
              >
              </v-text-field>
  
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title
                      >Html {{ $t("Download") }}</v-list-tile-title
                    >
                  </v-list-tile>
  
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title
                      >Excel {{ $t("Download") }}</v-list-tile-title
                    >
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
  <v-container fluid>
    <v-layout row wrap="">
                  <v-flex xs12 sm6 md2>
                    <tarihcomp
                      :etiket="$t('Starting-Date')"
                      v-bind:defaultvalue="'ok'"
                      :rules="[(v) => !!v || $t('Please-select-a-date')]"
                      v-model="searchParams.FirstDate"
                      v-bind:value="searchParams.FirstDate"
                    ></tarihcomp>
                  </v-flex>
  
                  <v-flex xs12 sm6 md2>
                    <tarihcomp
                      :etiket="$t('Finishing-Date')"
                      :rules="[(v) => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'"
                      v-model="searchParams.EndDate"
                      v-bind:value="searchParams.EndDate"
                    >
                    </tarihcomp>
                  </v-flex>
  
                  <v-flex xs12 sm12 md3>
                    <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="searchParams.ReferenceCode" >
                              </referansmerkezicomp>
                  </v-flex>
                
                  <v-flex>
                    <v-layout>
                      <v-btn color="info" @click="getList()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
  
                      <v-btn small="" @click="filtrele()" color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
  </v-container>
          <v-container fluid="">
          <v-layout row wrap>
            <v-flex xs12 sm6 md6 style="padding-right: 2px; padding-bottom: 4px">
            <v-toolbar flat >
        <v-toolbar-title>Devirler</v-toolbar-title>
      </v-toolbar>
                <v-card flat>
                  <v-data-table
                    :headers="headersTotalTransfers"
                    class="elevation-1"
                    disable-initial-sort 
                    hide-actions 
                    
                    items-per-page="-1"
          dense
                    :items="totalTransfersDetails"
                    :search="search"
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">
                        {{ props.item.Name }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Dept | moneyformat }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Credit | moneyformat}}
                      </td>
                      <td class="text-xs-left">
                        {{ CheckBalance(props.item.Balance)}}
                      </td>
                     
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
         
              <v-flex xs12 sm6 md6   justify-end>
            <v-toolbar flat>
        <v-toolbar-title>Toplamlar</v-toolbar-title>
      </v-toolbar>
                <v-card flat>
                  <v-data-table
                    :headers="headersTotals"
                    class="elevation-1"
                    disable-initial-sort 
                    hide-actions 
                    
                    items-per-page="-1"
          dense
                    :items="totalsDetails"
                    :search="search"
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">
                        {{ props.item.Name }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Dept | moneyformat }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Credit | moneyformat}}
                      </td>
                      <td class="text-xs-left">
                        {{ CheckBalance(props.item.Balance) }}
                      </td>
                     
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
          </v-layout>
        </v-container>
  
          <v-container fluid="">
            <v-card color="grey lighten-5" flat>
              <v-form ref="muhasebehesabagore" v-model="valid">
               
              </v-form>
              <v-layout>
                <v-flex xs12 sm12 md12 pt-2>
                  <v-card flat>
                    <v-data-table
                      :headers="headers"
                      class="elevation-1"
                      :rows-per-page-items="[50, 100]"
                      :items="itemDetails"
                      :search="search"
                    >
                      <template slot="items" slot-scope="props">
                        <td class="text-xs-left">
                          {{ props.item.RecieptDate | dateformat }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.RecieptNo }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.AccountingCode }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.AccountingCodeName  }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.DueDate | dateformat }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.Explanation1 }}
                        </td>
                        <td class="text-xs-right">
                          {{ props.item.Dept | moneyformat }}
                        </td>
                        <td class="text-xs-right">
                          {{ props.item.Credit | moneyformat }}
                        </td>
                        <td class="text-xs-right">
                          {{ CheckBalance(props.item.Balance) }}
                        </td>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>



        </v-layout>
      </v-card>
    </div>
  </template>
  
  <script>
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  import loadingcomp from "@/components/app/customcomp/loadingcomp";
  import helpers from "@/components/app/customcomp/helpers.js";
  import tarihcomp from "../../customcomp/tarihim";
  import auth from "../../../../api/auth";
  import catimuhasebekodu from "../comp/catimuhasebekodu.vue";
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
  export default {
    data() {
      return {
        dovizTipleri:[
    {
          text: "TL",
          value:0
     },
     {
          text: "Döviz",
          value:1
     },
     {
          text: "Döviz + TL",
          value:3
     },
    ],
        dialogfiltre:false,
        search: null,
        text1: null,
        snackbar: false,
        yetkidialog: false,
        loadingvmodel: false,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        valid: true,
        searchParams: {
          CompanyID: 0,
          FirstDate: null,
          EndDate: null,
          FirstAccountCode: null,
          EndAccountCode: null,
          ReferenceCode :null,
          ExtractType :0,
          ExcludeClosingFiche:0
        },
        accoutingCode: {
          CodeID: 0,
          CompanyID: 0,
          Code: null,
          CodeName: null,
          Text: null,
        },
        endAccoutingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
        credentials: JSON.parse(window.localStorage.getItem("credentials")),
        items: [],
      itemDetails: [],
      itemDetailsRoot: [],
      totalsDetails:[],
      headersTotals:[
      {
          text: 'Tanım'
        },
        {
          text: 'Borç'
        },
        {
          text: 'Alacak'
        },
        {
          text: 'Bakiye'
        },
      ],
      totalTransfersDetails:[],
      headersTotalTransfers:[
        {
          text: 'Tanım'
        },
        {
          text: 'Borç'
        },
        {
          text: 'Alacak'
        },
        {
          text: 'Bakiye'
        },
      ],
      headers: [
        {
          text: this.$t("Date"),
          sortable: false
        },
        {
          text: this.$t("Bill-No"),
          sortable: false
        },
        {
          text: this.$t("Line-No"),
          sortable: false
        },
        {
          text: "Açıklama",
          sortable: false
        },
        {
          text: "Evrak No",
          sortable: false
        },
        {
          text: this.$t("Maturity-Date"),
          sortable: false
        },
        {
          text: "Referans",
          sortable: false
        },
        {
          text: "Masraf Merkezi",
          sortable: false
        },
        {
          text: "TL",
          sortable: false
        },
        {
          text: "Döviz",
          sortable: false
        },
        {
          text: this.$t("Debit"),
          align: "right",
          sortable: false
        },
        {
          text: this.$t("Credit"),
          align: "right",
          sortable: false
        },
        {
          text: this.$t("Balance"),
          align: "right",
          sortable: false
        },
      ],
    };
  },
    methods: {
      filtrekayit()
    {
      this.dialogfiltre=false;
      this.getList();
    },
    filtreiptal()
    {
      this.dialogfiltre=false;
    },
    filtrele()
    {
      this.dialogfiltre=true;
    },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      CheckBalance(val) {
        if (val > 0) {
          return this.moneyformat(val) + " B";
        } else if (val == 0) {
          return this.moneyformat(val);
        } else {
          return this.moneyformat(val * -1) + " A";
        }
      },
      checkAccoutingValidate() {
        this.accoutingCode.CodeID = 0;
      },
      getparabirimi() {
        return helpers.getparabirimi();
      },
      getList() {
        if (this.searchParams.ReferenceCode == null || this.searchParams.ReferenceCode == 0 || this.searchParams.ReferenceCode == '') {
            this.text1 = this.$t('Reference-Code-field-cannot-be-empty');
            this.snackbar = true;
            return false;
          }
      var bastarih = new Date(this.searchParams.FirstDate);
      var bittarih = new Date(this.searchParams.EndDate);
      if (bastarih <= bittarih) {
        this.items = [];
        this.itemDetails = [];
        this.itemDetailsRoot = [];
        if (this.$refs.muhasebehesabagore.validate()) {
          this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;
            this.searchParams.FirstAccountCode = this.accoutingCode.Code;
            this.searchParams.EndAccountCode = this.endAccoutingCode.Code;
         
          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/ExtractReference",
              this.searchParams,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                if (response.body.Extracts.length > -1) {
                  this.items = response.body.Extracts;
                  console.log(this.items);
                  this.totalTransfersDetails=[];
                  this.totalsDetails=[];
                  for(
                        let tindex =0 ;
                        tindex<this.items[0].TotalPrices.length;
                        tindex++
                      ){
                        const dataTotal = this.items[0].TotalPrices[tindex];
                        this.totalsDetails.push(
                        {
                          Name:dataTotal.Currency + ' ' + 'Dönem Toplam:',
                         
                          Dept:dataTotal.PeriodDept,
                          Credit:dataTotal.PeriodCredit,
                          Balance: dataTotal.PeriodBalance

                        }
                      );   
                      }
                      for(
                        let tindex =0 ;
                        tindex<this.items[0].TotalPrices.length;
                        tindex++
                      ){
                        const dataTotal = this.items[0].TotalPrices[tindex];
                        this.totalsDetails.push(
                        {
                          Name:dataTotal.Currency + ' ' + 'Genel Toplam:',
                         
                          Dept:dataTotal.TotalDept,
                          Credit:dataTotal.TotalCredit,
                          Balance:dataTotal.TotalBalance

                        }
                      );   
                      }
                  for(
                        let tindex =0 ;
                        tindex<this.items[0].TotalPrices.length;
                        tindex++
                      ){
                        const dataTotal = this.items[0].TotalPrices[tindex];
                        this.totalTransfersDetails.push(
                        {
                          Name:dataTotal.Currency + ' ' + 'Devir Toplam:',
                         
                          Dept:dataTotal.TransferDept,
                          Credit:dataTotal.TransferCredit,
                          Balance:dataTotal.TransferBalance

                        }
                      );   
                      }
                  response.body.Extracts.forEach((element) => {
                   
                    for (
                      let index = 0;
                      index < element.Details.length;
                      index++
                    ) {
                      
                     

                      const data = element.Details[index];
                      console.log(data);
                      var kalemCurrency=data.Currency;
                      console.log(kalemCurrency);
                      var debit_=0;
                      var credit_=0;
                      var balance_=0;
                      if (element.Currencies[0]=='' && element.Currencies.length==1)
                      {
                                debit_=data.Dept[0];
                                credit_=data.Credit[0];
                                balance_=data.Balance[0];
                      }
                      else
                      {
                                let i=element.Currencies.indexOf(kalemCurrency);
                                debit_=data.Dept[i];
                                credit_=data.Credit[i];
                                balance_=data.Balance[i];
                      }
                      this.itemDetails.push(
                        {
                          RecieptDate:data.RecieptDate,
                          RecieptNo:data.RecieptNo,
                          DueDate:data.DueDate,
                          LineNo:data.LineNo,
                          Explanation1:data.Explanation1,
                          DocumentNo:data.DocumentNo,
                          DueDate:data.DueDate,
                          Referance:'',
                          CostCenter:'',
                          TL:data.TL,
                          Currency:data.Currency,
                          Dept:debit_,
                          Credit:credit_,
                          Balance:balance_

                        }
                      );
                    }
                  });
                } else {
                  this.text1 = this.$t("No-Records-Found");
                  this.snackbar = true;
                  this.items = [];
                }
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                } else {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                }
              }
            );
        }
      } else {
        this.text1 = this.$t("start-date-cannot-greater-than-end-date");
        this.snackbar = true;
      }
    },
      getListeski() {
        var bastarih = new Date(this.searchParams.FirstDate);
        var bittarih = new Date(this.searchParams.EndDate);
        if (bastarih <= bittarih) {
          this.items = [];
          this.itemDetails = [];
          if (this.searchParams.ReferenceCode == null || this.searchParams.ReferenceCode == 0 || this.searchParams.ReferenceCode == '') {
            this.text1 = this.$t('Reference-Code-field-cannot-be-empty');
            this.snackbar = true;
            return false;
          }
          if (this.$refs.muhasebehesabagore.validate()) {
            this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;
            this.searchParams.FirstAccountCode = this.accoutingCode.Code;
            this.searchParams.EndAccountCode = this.endAccoutingCode.Code;
           
         
  
            this.$http
              .post(
                auth.API_URL + "api/AccountingReports/ExtractReference",
                this.searchParams,
                {
                  headers: {
                    Authorization: "Bearer " + auth.getAuthHeader(),
                  },
                }
              )
              .then(
                (response) => {
                  if (response.body.Extracts.length > -1) {
                    this.items = response.body.Extracts;
  
                    response.body.Extracts.forEach((element) => {
                      for (
                        let index = 0;
                        index < element.Details.length;
                        index++
                      ) {
                        const data = element.Details[index];
                        this.itemDetails.push(data);
                      }
                    });
                  } else {
                    this.text1 = this.$t("No-Records-Found");
                    this.snackbar = true;
                    this.items = [];
                  }
                },
                (response) => {
                  if (response.status === 0) {
                    this.text1 = "Service Unavailable";
                    this.snackbar = true;
                  } else {
                    this.text1 = "Service Unavailable";
                    this.snackbar = true;
                  }
                }
              );
          }
        } else {
          this.text1 = this.$t("start-date-cannot-greater-than-end-date");
          this.snackbar = true;
        }
      },
      getListHtml() {
        if (this.searchParams.ReferenceCode == null || this.searchParams.ReferenceCode == 0 || this.searchParams.ReferenceCode == '') {
            this.text1 = this.$t('Reference-Code-field-cannot-be-empty');
            this.snackbar = true;
            return false;
          }
        var bastarih = new Date(this.searchParams.FirstDate);
        var bittarih = new Date(this.searchParams.EndDate);
        if (bastarih <= bittarih) {
          this.items = [];
          this.itemDetails = [];
         
           
            this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;
            this.searchParams.FirstAccountCode = this.accoutingCode.Code;
            this.searchParams.EndAccountCode = this.endAccoutingCode.Code;
           
  
            this.$http
              .post(
                auth.API_URL + "api/AccountingReports/ExtractAccountListHtml",
                this.searchParams,
                {
                  headers: {
                    Authorization: "Bearer " + auth.getAuthHeader(),
                  },
                }
              )
              .then(
                (response) => {
                  var blob = new Blob([response.data], {
                    type: "application/html",
                  });
                  var link = document.createElement("a");
                  link.href = window.URL.createObjectURL(blob);
                  link.download = "HesapEkstre.html";
                  link.click();
                },
                (response) => {
                  if (response.status === 0) {
                    this.text = "Service Unavailable";
                    this.snackbar = true;
                  } else {
                    this.text = "Service Unavailable";
                    this.snackbar = true;
                  }
                }
              );
          
        } else {
          this.text1 = this.$t("start-date-cannot-greater-than-end-date");
          this.snackbar = true;
        }
      },
      getListExcel() {
        if (this.searchParams.ReferenceCode == null || this.searchParams.ReferenceCode == 0 || this.searchParams.ReferenceCode == '') {
            this.text1 = this.$t('Reference-Code-field-cannot-be-empty');
            this.snackbar = true;
            return false;
          }
        var bastarih = new Date(this.searchParams.FirstDate);
        var bittarih = new Date(this.searchParams.EndDate);
        if (bastarih <= bittarih) {
          this.items = [];
          this.itemDetails = [];
          
           
            this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;
            this.searchParams.FirstAccountCode = this.accoutingCode.Code;
            this.searchParams.EndAccountCode = this.endAccoutingCode.Code;
           
  
            this.$http
              .post(
                auth.API_URL + "api/AccountingReports/ExtractAccountListExcel",
                this.searchParams,
                {
                  headers: {
                    Authorization: "Bearer " + auth.getAuthHeader(),
                  },
                  responseType: "arraybuffer",
                }
              )
              .then(
                (response) => {
                  var blob = new Blob([response.data], {
                    type: "application/xlsx",
                  });
                  var link = document.createElement("a");
                  link.href = window.URL.createObjectURL(blob);
                  link.download = "HesapEkstre.xlsx";
                  link.click();
                },
                (response) => {
                  if (response.status === 0) {
                    this.text = "Service Unavailable";
                    this.snackbar = true;
                  } else {
                    this.text = "Service Unavailable";
                    this.snackbar = true;
                  }
                }
              );
          
        } else {
          this.text1 = this.$t("start-date-cannot-greater-than-end-date");
          this.snackbar = true;
        }
      },
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
  
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      },
    },
    components: {
      yetkidialog,
      snackbarcomp,
      loadingcomp,
      tarihcomp,
      catimuhasebekodu,
      referansmerkezicomp
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.prevRoute = from.path;
      });
    },
    mounted() {
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
      if (this.sayfayetki.Status == true) {
        //YETKİ OK
      } else {
        this.$refs.yetkidialog
          .open(this.sayfayetki.Message, this.sayfayetki.islem)
          .then((sonuc) => {
            if (sonuc == true) {
              if (this.prevRoute != null) {
                var url = "#" + this.prevRoute;
  
                window.open(url, "_self");
              } else {
                var mainUrl = "#/";
                window.open(mainUrl, "_self");
              }
            }
          });
      }
    },
  };
  </script>
  
  <style>
  </style>
  
  